import React, { useState } from "react";
import { BbiTableConfig } from "../../smartCharts/components/BbiConfig/BbiTableConfig";
import Portal from "../../common/components/Portal";

const BbiInfo = ({ bbi_props }) => {
    const [showTableConfig, setTableConfig] = useState(false);

    const toggleTableConfig = () => setTableConfig(!showTableConfig);

    const renderTableConfig = () => {
        if (!showTableConfig) return null;
        const { building_fields } = bbi_props?.bbi_table?.bbi_table_column_configuration?.fields || [];
        return (
            <Portal
                body={<BbiTableConfig isView={true} fieldsConfig={building_fields} onCancel={() => toggleTableConfig()} />}
                onCancel={() => toggleTableConfig()}
                isClientProperty
            />
        );
    };

    return (
        <>
            {renderTableConfig()}
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>BBI</h3>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Label</h4>
                    <h3>{bbi_props?.bbi_heading?.name || "-"}</h3>
                </div>
            </div>
            {Object.keys(bbi_props?.bbi_heading?.custom_heading_props || {})?.length ||
            Object.keys(bbi_props?.bbi_heading?.structured_heading || {})?.length ? (
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Heading Type</h4>
                        <h3>{Object.keys(bbi_props?.bbi_heading?.custom_heading_props || {})?.length ? "Custom Heading" : "Predefined Heading"}</h3>
                    </div>
                </div>
            ) : null}
            {Object.keys(bbi_props?.bbi_heading?.custom_heading_props || {})?.length ? (
                <>
                    {" "}
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Font Name</h4>
                            <h3>{bbi_props?.bbi_heading?.custom_heading_props?.font_family || "-"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Font Size</h4>
                            <h3>{bbi_props?.bbi_heading?.custom_heading_props?.font_size || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Font Color</h4>
                            <h3>
                                {bbi_props?.bbi_heading?.custom_heading_props?.color || "-"}

                                <span
                                    className="color"
                                    style={{
                                        backgroundColor: bbi_props?.bbi_heading?.custom_heading_props?.color
                                            ? `#${bbi_props?.bbi_heading?.custom_heading_props?.color}`
                                            : "-"
                                    }}
                                ></span>
                            </h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Font Bold</h4>
                            <h3>{bbi_props?.bbi_heading?.custom_heading_props?.bold ? "Yes" : "No"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Alignment</h4>
                            <h3>{bbi_props?.bbi_heading?.custom_heading_props?.alignment || "-"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Background Color</h4>
                            <h3>
                                {bbi_props?.bbi_heading?.custom_heading_props?.bg_color || "-"}
                                <span
                                    className="color"
                                    style={{
                                        backgroundColor: bbi_props?.bbi_heading?.custom_heading_props?.bg_color
                                            ? `#${bbi_props?.bbi_heading?.custom_heading_props?.bg_color}`
                                            : "-"
                                    }}
                                ></span>
                            </h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Cell Margin Top</h4>
                            <h3>{bbi_props?.bbi_heading?.custom_heading_props?.cell_margin?.top || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Cell Margin Left</h4>
                            <h3>{bbi_props?.bbi_heading?.custom_heading_props?.cell_margin?.left || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Cell Margin Right</h4>
                            <h3>{bbi_props?.bbi_heading?.custom_heading_props?.cell_margin?.right || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Cell Margin Bottom</h4>
                            <h3>{bbi_props?.bbi_heading?.custom_heading_props?.cell_margin?.bottom || 0} px</h3>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Style</h4>
                            <h3>{bbi_props?.bbi_heading?.structured_heading?.heading_style || "-"}</h3>
                        </div>
                    </div>
                </>
            )}
            {/* <div className="col-md-12 basic-box main-heading mt-2">
                <h3>BSI Sub Heading</h3>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Heading Font Name</h4>
                    <h3>{(bbi_props?.bbi_sub_heading?.font_id && bbi_props?.bbi_sub_heading?.font_family) || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Heading Font Size</h4>
                    <h3>{bbi_props?.bbi_sub_heading?.font_size || 0} px</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Heading Font Color</h4>
                    <h3>
                        {bbi_props?.bbi_sub_heading?.color || "-"}

                        <span
                            className="color"
                            style={{
                                backgroundColor: bbi_props?.bbi_sub_heading?.color ? `#${bbi_props?.bbi_sub_heading?.color}` : "-"
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Heading Font Bold</h4>
                    <h3>{bbi_props?.bbi_sub_heading?.bold ? "Yes" : "No"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Heading Alignment</h4>
                    <h3>{bbi_props?.bbi_sub_heading?.alignment}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Heading Space Before</h4>
                    <h3>{bbi_props?.bbi_sub_heading?.space_before || 0} px</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Heading Space After</h4>
                    <h3>{bbi_props?.bbi_sub_heading?.space_after || 0} px</h3>
                </div>
            </div> */}
            <div className="col-md-3 basic-box"></div>
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>BBI Executive Summary</h3>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Executive Summary Heading Label</h4>
                    <h3>{bbi_props?.bbi_heading_executive_summary?.name || "-"}</h3>
                </div>
            </div>
            {Object.keys(bbi_props?.bbi_heading_executive_summary?.custom_heading_props || {})?.length ||
            Object.keys(bbi_props?.bbi_heading_executive_summary?.structured_heading || {})?.length ? (
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Executive Summary Heading Type</h4>
                        <h3>
                            {Object.keys(bbi_props?.bbi_heading_executive_summary?.custom_heading_props || {})?.length
                                ? "Custom Heading"
                                : "Predefined Heading"}
                        </h3>
                    </div>
                </div>
            ) : null}
            {Object.keys(bbi_props?.bbi_heading_executive_summary?.custom_heading_props || {})?.length ? (
                <>
                    {" "}
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Executive Summary Heading Font Name</h4>
                            <h3>{bbi_props?.bbi_heading_executive_summary?.custom_heading_props?.font_family || "-"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Executive Summary Heading Font Size</h4>
                            <h3>{bbi_props?.bbi_heading_executive_summary?.custom_heading_props?.font_size || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Executive Summary Heading Font Color</h4>
                            <h3>
                                {bbi_props?.bbi_heading_executive_summary?.color || "-"}

                                <span
                                    className="color"
                                    style={{
                                        backgroundColor: bbi_props?.bbi_heading_executive_summary?.custom_heading_props?.color
                                            ? `#${bbi_props?.bbi_heading_executive_summary?.custom_heading_props?.color}`
                                            : "-"
                                    }}
                                ></span>
                            </h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Executive Summary Heading Font Bold</h4>
                            <h3>{bbi_props?.bbi_heading_executive_summary?.custom_heading_props?.bold ? "Yes" : "No"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Executive Summary Heading Alignment</h4>
                            <h3>{bbi_props?.bbi_heading_executive_summary?.custom_heading_props?.alignment}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Executive Summary Background Color</h4>
                            <h3>
                                {bbi_props?.bbi_heading_executive_summary?.custom_heading_props?.bg_color || "-"}

                                <span
                                    className="color"
                                    style={{
                                        backgroundColor: bbi_props?.bbi_heading_executive_summary?.custom_heading_props?.bg_color
                                            ? `#${bbi_props?.bbi_heading_executive_summary?.custom_heading_props?.bg_color}`
                                            : "-"
                                    }}
                                ></span>
                            </h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Executive Summary Heading Margin Top</h4>
                            <h3>{bbi_props?.bbi_heading_executive_summary?.custom_heading_props?.cell_margin?.top || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Executive Summary Heading Margin Left</h4>
                            <h3>{bbi_props?.bbi_heading_executive_summary?.custom_heading_props?.cell_margin?.left || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Executive Summary Heading Margin Right</h4>
                            <h3>{bbi_props?.bbi_heading_executive_summary?.custom_heading_props?.cell_margin?.right || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Executive Summary Heading Margin Bottom</h4>
                            <h3>{bbi_props?.bbi_heading_executive_summary?.custom_heading_props?.cell_margin?.bottom || 0} px</h3>
                        </div>
                    </div>
                    {/* <div className="col-md-3 basic-box"></div> */}
                </>
            ) : (
                <>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Executive Summary Heading Style</h4>
                            <h3>{bbi_props?.bbi_heading_executive_summary?.structured_heading?.heading_style}</h3>
                        </div>
                    </div>
                </>
            )}
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>BBI Additionals (Executive Summary)</h3>
            </div>
            {Object.keys(bbi_props?.executive_summary?.additional?.custom_heading_props || {})?.length ||
            Object.keys(bbi_props?.executive_summary?.additional?.structured_heading || {})?.length ? (
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Additionals Heading Type</h4>
                        <h3>
                            {Object.keys(bbi_props?.executive_summary?.additional?.custom_heading_props || {})?.length
                                ? "Custom Heading"
                                : "Predefined Heading"}
                        </h3>
                    </div>
                </div>
            ) : null}
            {Object.keys(bbi_props?.executive_summary?.additional?.custom_heading_props || {})?.length ? (
                <>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Additionals Heading Font Name</h4>
                            <h3>{bbi_props?.executive_summary?.additional?.custom_heading_props?.font_family || "-"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Additionals Heading Font Size</h4>
                            <h3>{bbi_props?.executive_summary?.additional?.custom_heading_props?.font_size || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Additionals Heading Font Color</h4>
                            <h3>
                                {bbi_props?.executive_summary?.additional?.custom_heading_props?.color || "-"}

                                <span
                                    className="color"
                                    style={{
                                        backgroundColor: bbi_props?.executive_summary?.additional?.custom_heading_props?.color
                                            ? `#${bbi_props?.executive_summary?.additional?.custom_heading_props?.color}`
                                            : "-"
                                    }}
                                ></span>
                            </h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Additionals Heading Font Bold</h4>
                            <h3>{bbi_props?.executive_summary?.additional?.custom_heading_props?.bold ? "Yes" : "No"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Additionals Heading Alignment</h4>
                            <h3>{bbi_props?.executive_summary?.additional?.custom_heading_props?.alignment || "-"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Additionals Background Color</h4>
                            <h3>
                                {bbi_props?.executive_summary?.additional?.custom_heading_props?.bg_color || "-"}

                                <span
                                    className="color"
                                    style={{
                                        backgroundColor: bbi_props?.executive_summary?.additional?.custom_heading_props?.bg_color
                                            ? `#${bbi_props?.executive_summary?.additional?.custom_heading_props?.bg_color}`
                                            : "-"
                                    }}
                                ></span>
                            </h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Additionals Heading Cell Margin Top</h4>
                            <h3>{bbi_props?.executive_summary?.additional?.custom_heading_props?.cell_margin?.top || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Additionals Heading Cell Margin Left</h4>
                            <h3>{bbi_props?.executive_summary?.additional?.custom_heading_props?.cell_margin?.left || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Additionals Heading Cell Margin Right</h4>
                            <h3>{bbi_props?.executive_summary?.additional?.custom_heading_props?.cell_margin?.right || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Additionals Heading Cell Margin Bottom</h4>
                            <h3>{bbi_props?.executive_summary?.additional?.custom_heading_props?.cell_margin?.bottom || 0} px</h3>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Additionals Heading Style</h4>
                            <h3>{bbi_props?.executive_summary?.additional?.structured_heading?.heading_style || "-"}</h3>
                        </div>
                    </div>
                </>
            )}
            <div className="col-md-6 basic-box"></div>
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>BBI Trade (Executive Summary)</h3>
            </div>
            {Object.keys(bbi_props?.executive_summary?.trade?.custom_heading_props || {})?.length ||
            Object.keys(bbi_props?.executive_summary?.trade?.structured_heading || {})?.length ? (
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Trade Heading Type</h4>
                        <h3>
                            {Object.keys(bbi_props?.executive_summary?.trade?.custom_heading_props || {})?.length
                                ? "Custom Heading"
                                : "Predefined Heading"}
                        </h3>
                    </div>
                </div>
            ) : null}
            {Object.keys(bbi_props?.executive_summary?.trade?.custom_heading_props || {})?.length ? (
                <>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Trade Heading Font Name</h4>
                            <h3>{bbi_props?.executive_summary?.trade?.custom_heading_props?.font_family || "-"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Trade Heading Font Size</h4>
                            <h3>{bbi_props?.executive_summary?.trade?.custom_heading_props?.font_size || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Trade Heading Font Color</h4>
                            <h3>
                                {bbi_props?.executive_summary?.trade?.custom_heading_props?.color || "-"}

                                <span
                                    className="color"
                                    style={{
                                        backgroundColor: bbi_props?.executive_summary?.trade?.custom_heading_props?.color
                                            ? `#${bbi_props?.executive_summary?.trade?.custom_heading_props?.color}`
                                            : "-"
                                    }}
                                ></span>
                            </h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Trade Heading Font Bold</h4>
                            <h3>{bbi_props?.executive_summary?.trade?.custom_heading_props?.bold ? "Yes" : "No"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Trade Heading Alignment</h4>
                            <h3>{bbi_props?.executive_summary?.trade?.custom_heading_props?.alignment || "-"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Trade Heading Background Color</h4>
                            <h3>
                                {bbi_props?.executive_summary?.trade?.custom_heading_props?.bg_color || "-"}

                                <span
                                    className="color"
                                    style={{
                                        backgroundColor: bbi_props?.executive_summary?.trade?.custom_heading_props?.bg_color
                                            ? `#${bbi_props?.executive_summary?.trade?.custom_heading_props?.bg_color}`
                                            : "-"
                                    }}
                                ></span>
                            </h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Trade Heading Cell Margin Top</h4>
                            <h3>{bbi_props?.executive_summary?.trade?.custom_heading_props?.cell_margin?.top || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Trade Heading Cell Margin Left</h4>
                            <h3>{bbi_props?.executive_summary?.trade?.custom_heading_props?.cell_margin?.left || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Trade Heading Cell Margin Right</h4>
                            <h3>{bbi_props?.executive_summary?.trade?.custom_heading_props?.cell_margin?.right || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Trade Heading Cell Margin Bottom</h4>
                            <h3>{bbi_props?.executive_summary?.trade?.custom_heading_props?.cell_margin?.bottom || 0} px</h3>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Trade Heading Style</h4>
                            <h3>{bbi_props?.executive_summary?.trade?.structured_heading?.heading_style || "-"}</h3>
                        </div>
                    </div>
                </>
            )}
            <div className="col-md-6 basic-box"></div>
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>BBI Table</h3>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Column</h4>
                    <h3>{(bbi_props?.bbi_table?.table_columns && bbi_props?.bbi_table?.table_columns) || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Font Name</h4>
                    <h3>{(bbi_props?.bbi_table?.font_id && bbi_props?.bbi_table?.font_family) || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box"></div>
            <div className="col-md-3 basic-box"></div>
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>BBI Table Heading</h3>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Label</h4>
                    <h3>{bbi_props?.bbi_table?.table_heading?.name || "-"}</h3>
                </div>
            </div>
            {Object.keys(bbi_props?.bbi_table?.table_heading?.custom_heading_props || {})?.length ||
            Object.keys(bbi_props?.bbi_table?.table_heading?.structured_heading || {})?.length ? (
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Heading Type</h4>
                        <h3>
                            {Object.keys(bbi_props?.bbi_table?.table_heading?.custom_heading_props || {})?.length
                                ? "Custom Heading"
                                : "Predefined Heading"}
                        </h3>
                    </div>
                </div>
            ) : null}
            {Object.keys(bbi_props?.bbi_table?.table_heading?.custom_heading_props || {})?.length ? (
                <>
                    {" "}
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Font Name</h4>
                            <h3>{bbi_props?.bbi_table?.table_heading?.custom_heading_props?.font_family || "-"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Font Size</h4>
                            <h3>{bbi_props?.bbi_table?.table_heading?.custom_heading_props?.font_size || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Font Color</h4>
                            <h3>
                                {bbi_props?.bbi_table?.table_heading?.custom_heading_props?.color || "-"}

                                <span
                                    className="color"
                                    style={{
                                        backgroundColor: bbi_props?.bbi_table?.table_heading?.custom_heading_props?.color
                                            ? `#${bbi_props?.bbi_table?.table_heading?.custom_heading_props?.color}`
                                            : "-"
                                    }}
                                ></span>
                            </h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Font Bold</h4>
                            <h3>{bbi_props?.bbi_table?.table_heading?.custom_heading_props?.bold ? "Yes" : "No"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Alignment</h4>
                            <h3>{bbi_props?.bbi_table?.table_heading?.custom_heading_props?.alignment || "-"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Background Color</h4>
                            <h3>
                                {bbi_props?.bbi_table?.table_heading?.custom_heading_props?.bg_color || "-"}
                                <span
                                    className="color"
                                    style={{
                                        backgroundColor: bbi_props?.bbi_table?.table_heading?.custom_heading_props?.bg_color
                                            ? `#${bbi_props?.bbi_table?.table_heading?.custom_heading_props?.bg_color}`
                                            : "-"
                                    }}
                                ></span>
                            </h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Cell Margin Top</h4>
                            <h3>{bbi_props?.bbi_table?.table_heading?.custom_heading_props?.cell_margin?.top || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Cell Margin Left</h4>
                            <h3>{bbi_props?.bbi_table?.table_heading?.custom_heading_props?.cell_margin?.left || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Cell Margin Right</h4>
                            <h3>{bbi_props?.bbi_table?.table_heading?.custom_heading_props?.cell_margin?.right || 0} px</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Cell Margin Bottom</h4>
                            <h3>{bbi_props?.bbi_table?.table_heading?.custom_heading_props?.cell_margin?.bottom || 0} px</h3>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Heading Style</h4>
                            <h3>{bbi_props?.bbi_table?.table_heading?.structured_heading?.heading_style || "-"}</h3>
                        </div>
                    </div>
                </>
            )}
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>BBI Building Table Heading</h3>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Building Table Heading Font Name</h4>
                    <h3>
                        {(bbi_props?.bbi_table?.building_fields_heading?.font_id && bbi_props?.bbi_table?.building_fields_heading?.font_family) ||
                            "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Building Table Heading Font Size</h4>
                    <h3>{bbi_props?.bbi_table?.building_fields_heading?.font_size || 0} px</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Building Table Heading Font Color</h4>
                    <h3>
                        {bbi_props?.bbi_table?.building_fields_heading?.color || "-"}

                        <span
                            className="color"
                            style={{
                                backgroundColor: bbi_props?.bbi_table?.building_fields_heading?.color
                                    ? `#${bbi_props?.bbi_table?.building_fields_heading?.color}`
                                    : "-"
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Building Table Heading Font Bold</h4>
                    <h3>{bbi_props?.bbi_table?.building_fields_heading?.bold ? "Yes" : "No"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Building Table Heading Alignment</h4>
                    <h3>{bbi_props?.bbi_table?.building_fields_heading?.alignment || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Building Fields Background Color</h4>
                    <h3>
                        {bbi_props?.bbi_table?.building_fields_heading?.bg_color || "-"}

                        <span
                            className="color"
                            style={{
                                backgroundColor: bbi_props?.bbi_table?.building_fields_heading?.bg_color
                                    ? `#${bbi_props?.bbi_table?.building_fields_heading?.bg_color}`
                                    : "-"
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Building Table Heading Space Before</h4>
                    <h3>{bbi_props?.bbi_table?.building_fields_heading?.space_before || 0} px</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Building Table Heading Space After</h4>
                    <h3>{bbi_props?.bbi_table?.building_fields_heading?.space_after || 0} px</h3>
                </div>
            </div>
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>BBI Addition Fields Heading</h3>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Addition Fields Heading Font Name</h4>
                    <h3>
                        {(bbi_props?.bbi_table?.addition_fields_heading?.font_id && bbi_props?.bbi_table?.addition_fields_heading?.font_family) ||
                            "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Addition Fields Heading Font Size</h4>
                    <h3>{bbi_props?.bbi_table?.addition_fields_heading?.font_size || 0} px</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Addition Fields Heading Font Color</h4>
                    <h3>
                        {bbi_props?.bbi_table?.addition_fields_heading?.color || "-"}

                        <span
                            className="color"
                            style={{
                                backgroundColor: bbi_props?.bbi_table?.addition_fields_heading?.color
                                    ? `#${bbi_props?.bbi_table?.addition_fields_heading?.color}`
                                    : "-"
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Addition Fields Heading Font Bold</h4>
                    <h3>{bbi_props?.bbi_table?.addition_fields_heading?.bold ? "Yes" : "No"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Addition Fields Heading Alignment</h4>
                    <h3>{bbi_props?.bbi_table?.addition_fields_heading?.alignment || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Addition Fields Background Color</h4>
                    <h3>
                        {bbi_props?.bbi_table?.addition_fields_heading?.bg_color || "-"}

                        <span
                            className="color"
                            style={{
                                backgroundColor: bbi_props?.bbi_table?.addition_fields_heading?.bg_color
                                    ? `#${bbi_props?.bbi_table?.addition_fields_heading?.bg_color}`
                                    : "-"
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Addition Fields Heading Space Before</h4>
                    <h3>{bbi_props?.bbi_table?.addition_fields_heading?.space_before || 0} px</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Addition Fields Heading Space After</h4>
                    <h3>{bbi_props?.bbi_table?.addition_fields_heading?.space_after || 0} px</h3>
                </div>
            </div>
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>BBI Dynamic Fields Heading</h3>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Dynamic Fields Label</h4>
                    <h3>{(bbi_props?.bbi_table?.dynamic_fields_heading?.label && bbi_props?.bbi_table?.dynamic_fields_heading?.label) || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Dynamic Fields Heading Font Name</h4>
                    <h3>
                        {(bbi_props?.bbi_table?.dynamic_fields_heading?.font_id && bbi_props?.bbi_table?.dynamic_fields_heading?.font_family) || "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Dynamic Fields Heading Font Size</h4>
                    <h3>{bbi_props?.bbi_table?.dynamic_fields_heading?.font_size || 0} px</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Dynamic Fields Heading Font Color</h4>
                    <h3>
                        {bbi_props?.bbi_table?.dynamic_fields_heading?.color || "-"}

                        <span
                            className="color"
                            style={{
                                backgroundColor: bbi_props?.bbi_table?.dynamic_fields_heading?.color
                                    ? `#${bbi_props?.bbi_table?.dynamic_fields_heading?.color}`
                                    : "-"
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Dynamic Fields Heading Font Bold</h4>
                    <h3>{bbi_props?.bbi_table?.dynamic_fields_heading?.bold ? "Yes" : "No"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Dynamic Fields Heading Alignment</h4>
                    <h3>{bbi_props?.bbi_table?.dynamic_fields_heading?.alignment || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Dynamic Fields Background Color</h4>
                    <h3>
                        {bbi_props?.bbi_table?.dynamic_fields_heading?.bg_color || "-"}

                        <span
                            className="color"
                            style={{
                                backgroundColor: bbi_props?.bbi_table?.dynamic_fields_heading?.bg_color
                                    ? `#${bbi_props?.bbi_table?.dynamic_fields_heading?.bg_color}`
                                    : "-"
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Dynamic Fields Heading Space Before</h4>
                    <h3>{bbi_props?.bbi_table?.dynamic_fields_heading?.space_before || 0} px</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Dynamic Fields Heading Space After</h4>
                    <h3>{bbi_props?.bbi_table?.dynamic_fields_heading?.space_after || 0} px</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box"></div>
            <div className="col-md-3 basic-box"></div>
            <div className="col-md-3 basic-box"></div>
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>BBI Table Fields Heading</h3>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Fields Font Name</h4>
                    <h3>{(bbi_props?.bbi_table?.table_fields?.font_id && bbi_props?.bbi_table?.table_fields?.font_family) || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Fields Font Size</h4>
                    <h3>{bbi_props?.bbi_table?.table_fields?.font_size || 0} px</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Fields Font Color</h4>
                    <h3>
                        {bbi_props?.bbi_table?.table_fields?.color || "-"}

                        <span
                            className="color"
                            style={{
                                backgroundColor: bbi_props?.bbi_table?.table_fields?.color ? `#${bbi_props?.bbi_table?.table_fields?.color}` : "-"
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Fields Font Bold</h4>
                    <h3>{bbi_props?.bbi_table?.table_fields?.bold ? "Yes" : "No"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Fields Alignment</h4>
                    <h3>{bbi_props?.bbi_table?.table_fields?.alignment || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Fields Background Color</h4>
                    <h3>
                        {bbi_props?.bbi_table?.table_fields?.bg_color || "-"}

                        <span
                            className="color"
                            style={{
                                backgroundColor: bbi_props?.bbi_table?.table_fields?.bg_color
                                    ? `#${bbi_props?.bbi_table?.table_fields?.bg_color}`
                                    : "-"
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Fields Space Before</h4>
                    <h3>{bbi_props?.bbi_table?.table_fields?.space_before || 0} px</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Fields Space After</h4>
                    <h3>{bbi_props?.bbi_table?.table_fields?.space_after || 0} px</h3>
                </div>
            </div>
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>BBI Table Fields Value</h3>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Fields Valu Font Name</h4>
                    <h3>{(bbi_props?.bbi_table?.table_field_value?.font_id && bbi_props?.bbi_table?.table_field_value?.font_family) || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Fields Value Font Size</h4>
                    <h3>{bbi_props?.bbi_table?.table_field_value?.font_size || 0} px</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Fields Value Font Color</h4>
                    <h3>
                        {bbi_props?.bbi_table?.table_field_value?.color || "-"}

                        <span
                            className="color"
                            style={{
                                backgroundColor: bbi_props?.bbi_table?.table_field_value?.color
                                    ? `#${bbi_props?.bbi_table?.table_field_value?.color}`
                                    : "-"
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Fields Value Font Bold</h4>
                    <h3>{bbi_props?.bbi_table?.table_field_value?.bold ? "Yes" : "No"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Fields Value Alignment</h4>
                    <h3>{bbi_props?.bbi_table?.table_field_value?.alignment || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Fields Value Background Color</h4>
                    <h3>
                        {bbi_props?.bbi_table?.table_field_value?.bg_color || "-"}

                        <span
                            className="color"
                            style={{
                                backgroundColor: bbi_props?.bbi_table?.table_field_value?.bg_color
                                    ? `#${bbi_props?.bbi_table?.table_field_value?.bg_color}`
                                    : "-"
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Fields Value Space Before</h4>
                    <h3>{bbi_props?.bbi_table?.table_field_value?.space_before || 0} px</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Fields Value Space After</h4>
                    <h3>{bbi_props?.bbi_table?.table_field_value?.space_after || 0} px</h3>
                </div>
            </div>
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>BBI Table Column Configuration</h3>
            </div>
            <div className="col-md-12 basic-box main-heading">
                <h3>Building Fields</h3>
            </div>
            <div className="col-md-6 basic-box">
                <div className="codeOtr">
                    <button type="button" className="btn btn-primary" onClick={toggleTableConfig}>
                        View Column Config
                    </button>
                </div>
            </div>
            <div className="col-md-3 basic-box"></div> <div className="col-md-3 basic-box"></div>
            <div className="col-md-12 basic-box main-heading">
                <h3>Addition Fields</h3>
            </div>
            {bbi_props?.bbi_table?.bbi_table_column_configuration?.fields?.addition_fields &&
                Object.entries(
                    typeof bbi_props?.bbi_table?.bbi_table_column_configuration?.fields?.addition_fields === "string"
                        ? JSON.parse(bbi_props?.bbi_table?.bbi_table_column_configuration?.fields?.addition_fields)
                        : bbi_props?.bbi_table?.bbi_table_column_configuration?.fields?.addition_fields
                )?.map(([columnKey, columnData], index) => (
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>{columnData?.fe_label || "-"}</h4>
                            <div className="d-flex bbi-outerflds">
                                <div className="d-flex bbi-innerflds">
                                    <h4 className="vert-hed">Vertical Line:</h4>
                                    <h3 className="vert-data">{columnData?.vertical_line === true ? "True" : "False" || "-"} </h3>
                                </div>

                                <div className="d-flex">
                                    <h4 className="cells-hed">Cells:</h4>
                                    <h3 className="cell-data">{columnData?.fill_cells || "-"}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            <div className="col-md-3 basic-box"></div> <div className="col-md-3 basic-box"></div>
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>BBI Memo Properties</h3>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Field Property Status </h4>
                    <h3>
                        {" "}
                        {bbi_props?.memo_properties?.memo_props_active === true
                            ? "Active"
                            : bbi_props?.memo_properties?.memo_props_active === false
                            ? "Inactive"
                            : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Heading Font Name</h4>
                    <h3>{bbi_props?.memo_properties?.heading?.font_family || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Heading Font Size</h4>
                    <h3>{bbi_props?.memo_properties?.heading?.font_size ? `${bbi_props?.memo_properties?.heading?.font_size} pt` : "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Heading Font Color</h4>
                    <h3>
                        {bbi_props?.memo_properties?.heading?.font_color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: bbi_props?.memo_properties?.heading?.font_color
                                    ? `#${bbi_props?.memo_properties?.heading?.font_color}`
                                    : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Heading Font Bold </h4>
                    <h3>{bbi_props?.memo_properties?.heading?.font_bold ? "Yes" : "No" || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Body Font Name</h4>
                    <h3>{bbi_props?.memo_properties?.body?.font_family || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Body Font Size</h4>
                    <h3>{bbi_props?.memo_properties?.body?.font_size ? `${bbi_props?.memo_properties?.body?.font_size} pt` : "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Body Font Color</h4>
                    <h3>
                        {bbi_props?.memo_properties?.body?.font_color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: bbi_props?.memo_properties?.body?.font_color
                                    ? `#${bbi_props?.memo_properties?.body?.font_color}`
                                    : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Body Font Bold </h4>
                    <h3>{bbi_props?.memo_properties?.body?.font_bold ? "Yes" : "No" || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Paragraph Space Before</h4>
                    <h3>{bbi_props?.memo_properties?.paragraph_space_before ? `${bbi_props?.memo_properties?.paragraph_space_before} ` : 0} pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Paragraph Space After</h4>
                    <h3>{bbi_props?.memo_properties?.paragraph_space_after ? `${bbi_props?.memo_properties?.paragraph_space_after} ` : 0} pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Paragraph Alignment</h4>
                    <h3>{bbi_props?.memo_properties?.alignment ? `${bbi_props?.memo_properties?.alignment} ` : 0}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Paragraph Line Space</h4>
                    <h3>{bbi_props?.memo_properties?.line_space ? `${bbi_props?.memo_properties?.line_space}` : 0} pt</h3>
                </div>
            </div>
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>Stoplight</h3>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Stoplight Heading Label</h4>
                    <h3>{bbi_props?.stop_light?.main_heading?.name || "-"}</h3>
                </div>
            </div>
            {Object.keys(bbi_props?.stop_light?.main_heading?.custom_heading_props || {})?.length ||
            Object.keys(bbi_props?.stop_light?.main_heading?.structured_heading || {})?.length ? (
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Stoplight Heading Type</h4>
                        <h3>
                            {Object.keys(bbi_props?.stop_light?.main_heading?.custom_heading_props || {})?.length
                                ? "Custom Heading"
                                : "Predefined Heading"}
                        </h3>
                    </div>
                </div>
            ) : null}
            {Object.keys(bbi_props?.stop_light?.main_heading?.custom_heading_props || {})?.length ? (
                <>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Stoplight Heading Font Name</h4>
                            <h3>{bbi_props?.stop_light?.main_heading?.custom_heading_props?.font_family || "-"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Stoplight Heading Font Size</h4>
                            <h3>{bbi_props?.stop_light?.main_heading?.custom_heading_props?.font_size || 0} Pt</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Stoplight Heading Font Color</h4>
                            <h3>
                                {bbi_props?.stop_light?.main_heading?.custom_heading_props?.color || "-"}

                                <span
                                    className="color"
                                    style={{
                                        backgroundColor: bbi_props?.stop_light?.main_heading?.custom_heading_props?.color
                                            ? `#${bbi_props?.stop_light?.main_heading?.custom_heading_props?.color}`
                                            : "-"
                                    }}
                                ></span>
                            </h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Stoplight Heading Font Bold</h4>
                            <h3>{bbi_props?.stop_light?.main_heading?.custom_heading_props?.bold ? "Yes" : "No"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Stoplight Heading Alignment</h4>
                            <h3>{bbi_props?.stop_light?.main_heading?.custom_heading_props?.alignment || "-"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Stoplight Background Color</h4>
                            <h3>
                                {bbi_props?.stop_light?.main_heading?.custom_heading_props?.bg_color || "-"}

                                <span
                                    className="color"
                                    style={{
                                        backgroundColor: bbi_props?.stop_light?.main_heading?.custom_heading_props?.bg_color
                                            ? `#${bbi_props?.stop_light?.main_heading?.custom_heading_props?.bg_color}`
                                            : "-"
                                    }}
                                ></span>
                            </h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Stoplight Heading Cell Margin Top</h4>
                            <h3>{bbi_props?.stop_light?.main_heading?.custom_heading_props?.cell_margin?.top || 0} inch</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Stoplight Heading Cell Margin Left</h4>
                            <h3>{bbi_props?.stop_light?.main_heading?.custom_heading_props?.cell_margin?.left || 0} inch</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Stoplight Heading Cell Margin Right</h4>
                            <h3>{bbi_props?.stop_light?.main_heading?.custom_heading_props?.cell_margin?.right || 0} inch</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Stoplight Heading Cell Margin Bottom</h4>
                            <h3>{bbi_props?.stop_light?.main_heading?.custom_heading_props?.cell_margin?.bottom || 0} inch</h3>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Stoplight Heading Style</h4>
                            <h3>{bbi_props?.stop_light?.main_heading?.structured_heading?.heading_style || "-"}</h3>
                        </div>
                    </div>
                </>
            )}
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Column Sort Order</h4>
                    <h3>{bbi_props?.stop_light?.column_sort_order?.order || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Row Sort Order</h4>
                    <h3>{bbi_props?.stop_light?.row_sort_order?.order || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Blank Space</h4>
                    <h3>{bbi_props?.stop_light?.table_blank_space_config?.font_size || "-"} Pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box"></div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Heading Label</h4>
                    <h3>{bbi_props?.stop_light?.table_heading?.label || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Heading Font Name</h4>
                    <h3>{bbi_props?.stop_light?.table_heading?.font_family || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Heading Font Size</h4>
                    <h3>{bbi_props?.stop_light?.table_heading?.font_size || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Heading Font Color</h4>
                    <h3>
                        {bbi_props?.stop_light?.table_heading?.color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: bbi_props?.stop_light?.table_heading?.color ? `#${bbi_props?.stop_light?.table_heading?.color}` : "-"
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Heading Font Bold</h4>
                    <h3>{bbi_props?.stop_light?.table_heading?.bold ? "Yes" : "No"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Heading Alignment</h4>
                    <h3>{bbi_props?.stop_light?.table_heading?.alignment || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Heading Space Before</h4>
                    <h3>{bbi_props?.stop_light?.table_heading?.before || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Heading Space After</h4>
                    <h3>{bbi_props?.stop_light?.table_heading?.after || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Column Heading Font Name</h4>
                    <h3>{bbi_props?.stop_light?.table_columns_heading?.font_family || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Column Heading Font Size</h4>
                    <h3>{bbi_props?.stop_light?.table_columns_heading?.font_size || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Column Heading Font Color</h4>
                    <h3>
                        {bbi_props?.stop_light?.table_columns_heading?.color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: bbi_props?.stop_light?.table_columns_heading?.color
                                    ? `#${bbi_props?.stop_light?.table_columns_heading?.color}`
                                    : "-"
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Column Heading Font Bold</h4>
                    <h3>{bbi_props?.stop_light?.table_columns_heading?.bold ? "Yes" : "No"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Column Heading Alignment</h4>
                    <h3>{bbi_props?.stop_light?.table_columns_heading?.alignment || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Column Heading Space Before</h4>
                    <h3>{bbi_props?.stop_light?.table_columns_heading?.before || "-"} pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Column Heading Space After</h4>
                    <h3>{bbi_props?.stop_light?.table_columns_heading?.after || "-"} pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box"></div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Sub Heading Label</h4>
                    <h3>{bbi_props?.stop_light?.table_heading_text?.label || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Sub Heading Font Name</h4>
                    <h3>{bbi_props?.stop_light?.table_heading_text?.font_family || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Sub Heading Font Size</h4>
                    <h3>{bbi_props?.stop_light?.table_heading_text?.font_size || "-"} pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Sub Heading Font Color</h4>
                    <h3>
                        {bbi_props?.stop_light?.table_heading_text?.color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: bbi_props?.stop_light?.table_heading_text?.color
                                    ? `#${bbi_props?.stop_light?.table_heading_text?.color}`
                                    : "-"
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Sub Heading Font Bold</h4>
                    <h3>{bbi_props?.stop_light?.table_heading_text?.bold ? "Yes" : "No"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Sub Heading Alignment</h4>
                    <h3>{bbi_props?.stop_light?.table_heading_text?.alignment ?? "-"} Pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Sub Heading Space Before</h4>
                    <h3>{bbi_props?.stop_light?.table_heading_text?.space_before ?? "-"} Pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Sub Heading Space After</h4>
                    <h3>{bbi_props?.stop_light?.table_heading_text?.space_after ?? "-"} Pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Font Name</h4>
                    <h3>{bbi_props?.stop_light?.table_text?.font_family || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Font Size</h4>
                    <h3>{bbi_props?.stop_light?.table_text?.font_size ?? "-"} Pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Font Color</h4>
                    <h3>
                        {bbi_props?.stop_light?.table_text?.color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: bbi_props?.stop_light?.table_text?.color ? `#${bbi_props?.stop_light?.table_text?.color}` : "-"
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Font Bold</h4>
                    <h3>{bbi_props?.stop_light?.table_text?.bold ? "Yes" : "No"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Space Before</h4>
                    <h3>{bbi_props?.stop_light?.table_text?.space_before ?? "-"} Pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Space After</h4>
                    <h3>{bbi_props?.stop_light?.table_text?.space_after ?? "-"} Pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Alignment</h4>
                    <h3>{bbi_props?.stop_light?.table_text?.alignment ?? "-"} Pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Line Space</h4>
                    <h3>{bbi_props?.stop_light?.table_text?.line_spacing ?? "-"} Pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Color Icon Size</h4>
                    <h3>{bbi_props?.stop_light?.table_text_color?.font_size ?? "-"} Pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Color Icon Bold</h4>
                    <h3>{bbi_props?.stop_light?.table_text_color?.bold ? "Yes" : "No"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Color Icon Space Before</h4>
                    <h3>{bbi_props?.stop_light?.table_text_color?.space_before ?? "-"} Pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Color Icon Space After</h4>
                    <h3>{bbi_props?.stop_light?.table_text_color?.space_after ?? "-"} Pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Color Icon Alignment</h4>
                    <h3>{bbi_props?.stop_light?.table_text_color?.alignment ?? "-"} Pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Color Icon Line Space</h4>
                    <h3>{bbi_props?.stop_light?.table_text_color?.line_spacing ?? "-"} Pt</h3>
                </div>
            </div>
            <div className="col-md-6 basic-box"></div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Legend Text Font Name</h4>
                    <h3>{bbi_props?.stop_light?.legends?.legends?.font_family || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Legend Text Font Size</h4>
                    <h3>{bbi_props?.stop_light?.legends?.legends?.font_size ?? "-"} Pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Legend Text Font Color</h4>
                    <h3>
                        {bbi_props?.stop_light?.legends?.legends?.color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: bbi_props?.stop_light?.legends?.legends?.color
                                    ? `#${bbi_props?.stop_light?.legends?.legends?.color}`
                                    : "-"
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Legend Text Order</h4>
                    <h3>{bbi_props?.stop_light?.legends?.legends?.order || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Legend Text Alignment</h4>
                    <h3>{bbi_props?.stop_light?.legends?.legends?.alignment || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Legend Icon Size</h4>
                    <h3>{bbi_props?.stop_light?.legends?.color?.font_size ?? "-"} Pt</h3>
                </div>
            </div>
        </>
    );
};

export default BbiInfo;
